import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTenantConfig, useServices } from '../contexts';
import { useAuth } from '@teko/auth-react';

export const useUnreadNotification = () => {
  const router = useRouter();
  const { user } = useAuth();
  const { notificationAppId } = useTenantConfig();
  const [unreadNotification, setUnreadNotification] = useState(0);

  const { notificationService } = useServices();

  useEffect(() => {
    const token = localStorage.getItem('fcmToken');
    const unreadParams = {
      app_id: notificationAppId,
      ignore_pending_send: 0,
      token: token ?? undefined,
    };
    if (notificationAppId) {
      notificationService.unreadCount(unreadParams).then((data) => {
        if (data) {
          setUnreadNotification(data.count);
        }
      });
    }
  }, [user?.userId, router, notificationAppId]);

  return {
    unreadNotification,
  };
};
